module.exports = __webpack_public_path__ + "ath_game_web/img/4.6.71133071.png";